import { render, staticRenderFns } from "./FaqView.vue?vue&type=template&id=a9986dca&scoped=true"
import script from "./FaqView.vue?vue&type=script&lang=js"
export * from "./FaqView.vue?vue&type=script&lang=js"
import style0 from "./FaqView.vue?vue&type=style&index=0&id=a9986dca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9986dca",
  null
  
)

export default component.exports